import * as React from 'react';

import DynamicIcon from './dynamicicon';
import JisButton from './controls/jisButton';



export default function JisPrompt(props) {


  return (
   <div>
   {props.open && <div className={ "dialog-box open" }>
                    
                   
                    <div className="wrapper">
                    <h3>{props.title} </h3>
                    <div className="main" style={{padding:16}}>
                     
                        {props.children} 
                        <div className="btns">
                            <JisButton onClick={props.onOk} icon="check_circle">
                                Yes
                            </JisButton>
                            <JisButton onClick={props.onCancel} icon="close" variant={'outline'}>
                                No
                            </JisButton>
                            
                            
                        </div>  
                    </div>
                </div>
                
                
            </div>} 
  
   </div> 
  );
}
